export default __webpack_public_path__ + "static/media/logo-watermark.8d8db63d.svg";